(function () {

  /* ==================================================
     🔒 PREVENT CART FORM SUBMIT (STOP REDIRECT)
  ================================================== */
  document.addEventListener('submit', function (e) {
    if (e.target.closest('#cartOffcanvas')) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  });

  /* ==================================================
     🔒 FORCE BUTTON TYPE (AVOID SUBMIT)
  ================================================== */
  document.addEventListener('click', function () {
    document.querySelectorAll('#cartOffcanvas button').forEach(btn => {
      if (!btn.hasAttribute('type')) {
        btn.setAttribute('type', 'button');
      }
    });
  });

  /* ==================================================
     INTERCEPT IWISH ADD TO CART (ORIGINAL FLOW)
  ================================================== */
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form.classList.contains('iwish-product-form')) return;

    e.preventDefault();
    addToCart(form);
  });

  /* ==================================================
     ADD TO CART AJAX
  ================================================== */
  function addToCart(form) {
    const formData = new FormData(form);
    const btn = form.querySelector('[type="submit"]');

    if (btn) btn.classList.add('loading');

    showRiodeSpinner(); // spinner first

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' }
    })
      .then(res => {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(() => refreshOffcanvasCart())
      .catch(err => {
        console.error(err);
        alert('Unable to add product to cart');
        hideRiodeSpinner();
      })
      .finally(() => {
        if (btn) btn.classList.remove('loading');
      });
  }

  /* ==================================================
     FETCH CART + UPDATE UI
  ================================================== */
  function refreshOffcanvasCart() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        renderCartItems(cart);
        updateSubtotal(cart);
        updateCartCounter(cart);
        toggleEmptyState(cart);

        openCartOffcanvas(); // open AFTER data exists
        hideRiodeSpinner();
      });
  }

  /* ==================================================
     SPINNER CONTROL
  ================================================== */
  function showRiodeSpinner() {
    const spinner = document.querySelector('#cartOffcanvas .spinner-box');
    if (spinner) spinner.style.display = 'block';
  }

  function hideRiodeSpinner() {
    const spinner = document.querySelector('#cartOffcanvas .spinner-box');
    if (spinner) spinner.style.display = 'none';
  }

  /* ==================================================
     RENDER CART ITEMS (WITH QUANTITY BOX)
  ================================================== */
  function renderCartItems(cart) {
    const list = document.querySelector('.items__cart-offcanvas');
    if (!list) return;

    list.innerHTML = '';

    cart.items.forEach(item => {
      const li = document.createElement('li');
      li.className = `item__${item.id} item__cart item__normal row _pb-2 position-relative`;

      li.innerHTML = `
        <div class="image__cart col is-contain">
          <a href="${item.url}" class="aspectRatio">
            <img src="${item.image}&width=240" alt="${item.product_title}">
          </a>
        </div>

        <div class="info__cart col">
          <h4 class="product-name h6">
            <a href="${item.url}">${item.product_title}</a>
          </h4>

          <span class="price">
            <span class="money">$${(item.price / 100).toFixed(2)}</span>
          </span>

          <div class="action__cart">
            <div class="quantity">
              <div class="control">
                <button type="button" class="btn-number qtyminus" data-key="${item.key}"></button>
                <input
                  type="text"
                  class="input-qty"
                  value="${item.quantity}"
                  data-key="${item.key}"
                  data-min="1"
                  size="4"
                  pattern="[0-9]*"
                >
                <button type="button" class="btn-number qtyplus" data-key="${item.key}"></button>
              </div>
            </div>

            <button type="button" class="btn btn-link act-remove" data-key="${item.key}">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      `;

      list.appendChild(li);
    });
  }

  /* ==================================================
     UPDATE SUBTOTAL (DRAWER + HEADER)
  ================================================== */
  function updateSubtotal(cart) {
    document.querySelectorAll('.mysubb').forEach(el => {
      el.textContent = `$${(cart.total_price / 100).toFixed(2)}`;
    });

    const cartCost = document.querySelector('.cartCost');
    if (cartCost) {
      cartCost.setAttribute('data-price', cart.total_price);
    }
  }

  /* ==================================================
     UPDATE CART COUNTER
  ================================================== */
  function updateCartCounter(cart) {
    document.querySelectorAll('.cartCount').forEach(el => {
      el.textContent = cart.item_count;
    });
  }

  /* ==================================================
     EMPTY / HAS ITEM STATE
  ================================================== */
  function toggleEmptyState(cart) {
    const emptyText = document.querySelector('.empty');
    const footer = document.querySelector('.footer__cart-offcanvas');

    if (cart.item_count > 0) {
      if (emptyText) emptyText.style.display = 'none';
      if (footer) footer.style.display = 'block';
    } else {
      if (emptyText) emptyText.style.display = 'block';
      if (footer) footer.style.display = 'none';
    }
  }

  /* ==================================================
     OPEN CART OFFCANVAS
  ================================================== */
  function openCartOffcanvas() {
    const btn =
      document.querySelector('[data-bs-target="#cartOffcanvas"]') ||
      document.querySelector('.cart-toggle');

    if (btn) btn.click();
  }

})();
